// extracted by mini-css-extract-plugin
export default {"root":"SubscriptionPlanPage_root__dvqDT","nav":"SubscriptionPlanPage_nav__hDJ97","wrapper":"SubscriptionPlanPage_wrapper__fDtKd"};